import { Injectable } from '@angular/core';

@Injectable({ providedIn: 'root' })
export class LogServiceConfig {
  isLogToConsole = true;
}

@Injectable({ providedIn: 'root' })
export class LogService {
  constructor(private config: LogServiceConfig) {}

  log(...args) {
    if (this.config.isLogToConsole) {
      console.log.apply(console, args); // eslint-disable-line no-console
    }
  }

  error(...args) {
    if (this.config.isLogToConsole) {
      console.error.apply(console, args); // eslint-disable-line no-console
    }
  }

  warn(...args) {
    if (this.config.isLogToConsole) {
      console.warn.apply(console, args); // eslint-disable-line no-console
    }
  }
}
